import { render, staticRenderFns } from "./HUDPage.vue?vue&type=template&id=e212b314&scoped=true&"
import script from "./HUDPage.vue?vue&type=script&lang=ts&"
export * from "./HUDPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e212b314",
  null
  
)

export default component.exports